import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// styles
import './style.scss';

// Multibrand-UI Components
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import StyledContainer from '@zg-rentals/multibrand-ui/lib/StyledContainer';

// TODO: update mui Row, Col to use zrs-comet
import { Container } from '@zillow/zrs-comet';

import Breadcrumb from 'app/shared/components/Breadcrumb';

import AuthCheckWrapper from 'app/shared/containers/AuthCheckWrapper';
import LeadsForListingPage from 'app/shared/containers/LeadsForListingPage';
import { PropertiesSelectors } from 'app/shared/selectors';

import PostingActions from 'app/shared/actions/PostingActions';
import PropertiesActions from 'app/shared/actions/PropertiesActions';

import pathsManifest from 'app/shared/pathsManifest';

const propTypes = {
    currentProperty: PropTypes.object.isRequired,
    propertyId: PropTypes.string.isRequired,
};

class GlobalLeadsPage extends React.Component {
    componentDidMount() {
        this.props
            .dispatch(PostingActions.property.getDetails(this.props.propertyId))
            .then((response) => {
                const {
                    street,
                    city,
                    state,
                    zip,
                    unit,
                    geo,
                    listingTypeCode,
                    propertyTypeCode,
                    numUnits,
                    active,
                    archived,
                } = response;

                const updatedPropertyData = {
                    street,
                    city,
                    state,
                    zip,
                    unit,
                    geo,
                    listingTypeCode,
                    propertyTypeCode,
                    numUnits,
                    active,
                    archived,
                };

                this.props.dispatch(PropertiesActions.updateCurrentProperty(updatedPropertyData));
            });
    }

    render() {
        const {
            street, city, state, zip,
        } = this.props.currentProperty;
        const paths = pathsManifest.getAllPaths();
        const { contactsPage } = paths;
        return (
            <AuthCheckWrapper requireStrongAuthentication={false}>
                <Container>
                    <div className="GlobalLeadsPage-Container">
                        <Breadcrumb title="Contacts" redirectTo={contactsPage} />
                        <StyledContainer backgroundColor="white" className="GlobalLeadsPage-LeadsContainer">
                            <div className="GlobalLeadsPage-AddressContainer">
                                <Text type="h1" className="GlobalLeadsPage-address">
                                    {street}
                                </Text>
                                <Text type="h5" className="GlobalLeadsPage-cityStateZip">
                                    {`${city}, ${state} ${zip}`}
                                </Text>
                            </div>
                            <LeadsForListingPage {...this.props} />
                        </StyledContainer>
                    </div>
                </Container>
            </AuthCheckWrapper>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    currentProperty: PropertiesSelectors.makeCurrentProperty(state),
    propertyId: ownProps.match.params.propertyId,
});

GlobalLeadsPage.propTypes = propTypes;

export default connect(mapStateToProps)(GlobalLeadsPage);
